import {
  Autocomplete,
  Box,
  Card,
  FormControl,
  IconButton,
  InputLabel,
  Select,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import PermissionsToggle from "./PermissionsToggle";
import { Colours } from "../assets/global/Theme-variable";
import DeleteIcon from "@mui/icons-material/Delete";
import { SortableList } from "./SortableList";
import { capitalise } from "../views/datagrids/utils";
import { DataGridContext } from "../context/DataGridContext";

export default function Rule({
  rule,
  permissionObject,
  handleEditActions,
  handleEditRule,
  handleEditAllow,
  handleRuleDelete,
  error,
  handleEditType,
  handleEditSites,
}) {

  const { data } = useContext(DataGridContext);
  const index = permissionObject.findIndex(
      (modifier) => modifier.id === rule.id
    );

  const pageOptions_pages = [
    "all",
    "screens",
    "items",
    "tags",
    "staff",
    "majorcategories",
    "categories",
    // "configuration",
    "pricing",
    "printers",
    "sites",
    // "permissions",
    "users",
    "userTypes",
    "policies",
    "macros",
    "pricebands",
    "analysisCategories",
    "modifiers",
    "paymentMethods",
    "settings",
  ];

  const pageOptions_reportSets = ["All", "Basic", "Management", "Index"];

  const [pageOptions, setPageOptions] = React.useState(pageOptions_pages || pageOptions_reportSets);

  React.useEffect(()=> {
    var newOptions = [];
    if ( 
      permissionObject[index]?.api?.includes("reportSet")
    ) {
      newOptions = [...pageOptions_reportSets];
    } else {
      newOptions = [...pageOptions_pages];
    }
    setPageOptions(newOptions);
  }, [index]);

  const actions2 = [
    {
      pages: ["all", "*"],
      actions: [
        {
          name: "All",
          value: "*",
        },
        {
          name: "View",
          value: "view",
        },
        {
          name: "Create",
          value: "create",
        },
        {
          name: "Edit",
          value: "edit",
        },
        {
          name: "Delete",
          value: "delete",
        },
        {
          name: "Undelete",
          value: "undelete",
        },
      ],
    },
    {
      pages: ["pricing"],
      actions: [
        {
          name: "All",
          value: "*",
        },
        {
          name: "View",
          value: "view",
        },
        {
          name: "Create",
          value: "create",
        },
        {
          name: "Edit",
          value: "edit",
        },
        {
          name: "Delete",
          value: "delete",
        },
        {
          name: "Undelete",
          value: "undelete",
        },
        {
          name: "Bulk Pricing",
          value: "bulkPriceEdit",
        },
      ],
    },
    {
      pages: ["screens"],
      actions: [
        {
          name: "All",
          value: "*",
        },
        {
          name: "View",
          value: "view",
        },
        {
          name: "Create",
          value: "create",
        },
        {
          name: "Edit",
          value: "edit",
        },
        {
          name: "Delete",
          value: "delete",
        },
        {
          name: "Undelete",
          value: "undelete",
        },
        {
          name: "disableTillSending",
          value: "Disable till sending",
        },
      ],
    },
  ];

  function getActionsForSelectedPages(pagesSelected, actionsArray) {
    const resultActions = new Map();
    let matched = false;

    actionsArray.forEach((entry, index) => {
      const hasMatch = entry.pages.some((page) => pagesSelected.includes(page));
      if (hasMatch) {
        matched = true;
        entry.actions.forEach((action) => {
          resultActions.set(action.value, action);
        });
      }
    });

    // If no matches were found, use the first object's actions
    if (!matched && actionsArray.length > 0) {
      actionsArray[0].actions.forEach((action) => {
        resultActions.set(action.value, action);
      });
    }

    return Array.from(resultActions.values());
  }

  const reportActions = [
    {
      name: "All",
      value: "*",
    },
    {
      name: "View",
      value: "view",
    },
    {
      name: "Create",
      value: "create",
    },
    {
      name: "Edit",
      value: "edit",
    },
    {
      name: "Delete",
      value: "delete",
    },
  ];

  const sites = data.sites.map((s) => {
    return { value: s.site_number, label: s.site_number };
  });

  const siteOptions = [
    {
      value: "*",
      label: "All",
    },
  ].concat(sites);

  const getSelectedSites = () => {
    const items = permissionObject[index]?.sites?.map((s) =>
      siteOptions.find((i) => i?.value?.toString() === s?.toString())
    ).filter((site)=> site !== undefined);
    return items ? items : [siteOptions[0]];
  };

  const getSelectedPages = () => {
    const items = permissionObject[index]?.page?.map((s) => {
      const item = pageOptions.find(
        (i) => i?.toLowerCase() === s?.toLowerCase()
      );
      return typeof item !== "undefined" ? item : s === "*" ? "All" : s;
    });

    return items ? items : [pageOptions[0]];
  };
  return (
    <Card
      elevation={0}
      key={rule.id}
      sx={{ width: "100%", backgroundColor: "none", pl: 0, pr: 0 }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "row",
          gap: 2,
          mt: 2,
          alignItems: "center",
        }}
      >
        <SortableList.DragHandle key={rule.id} />

        {/* API Text Field */}
        <TextField
          label={"API"}
          size="small"
          type="text"
          sx={{ width: 300 }}
          onChange={(e, data) => handleEditType(e, index)}
          value={
            permissionObject[index]?.api &&
              Array.isArray(permissionObject[index]?.api) &&
              permissionObject[index]?.api[0] === "*"
              ? "Any"
              : permissionObject[index]?.api &&
                Array.isArray(permissionObject[index]?.api)
                ? permissionObject[index]?.api[0]
                : permissionObject[index]?.api &&
                  permissionObject[index]?.api === "*"
                  ? "Any"
                  : "Any"
          }
        />

        {/* Sites Selector */}
        <Autocomplete
          multiple
          limitTags={3}
          id="multiple-limit-tags"
          options={siteOptions}
          size="small"
          getOptionLabel={(option) => option?.label}
          value={getSelectedSites()}
          onChange={(e, data) => {
            console.log(e, data);
            handleEditSites(
              data?.map((v) => v?.value),
              index
            );
          }}
          renderInput={(params) => <TextField {...params} label="Sites" />}
          sx={{
            width: 600,
            "& .MuiOutlinedInput-root": {
              paddingRight: "10px!important",
            },
          }}
        />
        {/* Page Selector */}
      
        
            <Autocomplete
              multiple
              id="tags-filled"
              options={pageOptions}
              value={getSelectedPages()}
              onChange={(e, data) => {
                console.log(e, data);
                handleEditRule(
                  data?.map((v) => (v === "All" ? "*" : v)),
                  index
                );
              }}
              sx={{
                width: 600,
                "& .MuiOutlinedInput-root": {
                  paddingRight: "10px!important",
                },
              }}
              size="small"
              freeSolo
              renderInput={(params) => <TextField {...params} label="Pages" />}
            />

        <FormControl sx={{ minWidth: 120 }} size="small">
          <InputLabel id="demo-select-small-label">Actions</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={permissionObject[index]?.actions}
            label="Actions"
            onChange={(e) => handleEditActions(e, index)}
            multiple
          >
            {
              permissionObject[index]?.api?.includes("reportSet") ||
                permissionObject[index]?.api?.includes("reports") ||
                permissionObject[index]?.api?.includes("report")
                ? reportActions.map((action) => (
                  <MenuItem key={action.value} value={action.value}>
                    {action.name}
                  </MenuItem>
                ))
                :
                getActionsForSelectedPages(
                  permissionObject[index]?.page,
                  actions2
                )?.map((action) => (
                  <MenuItem key={action.value} value={action.value}>
                    {action.name}
                  </MenuItem>
                ))
            }
          </Select>
        </FormControl>

        <PermissionsToggle
          value={permissionObject[index]?.allow}
          onChange={(e, newValue) => handleEditAllow(e, newValue, index)}
          action="edit"
        />
        <IconButton
          color={Colours.gsblue}
          sx={{ justifySelf: "flex-end", color: Colours.gsblue }}
          onClick={(e) => {
            handleRuleDelete(e, index);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
      <Box
        sx={{ display: "flex", gap: 2, flexDirection: "row", width: "100%" }}
      >
        <Box sx={{ width: "24px" }} />
        <Box sx={{ flex: 1 }}>
          {error?.includes(rule.id) && (
            <Typography sx={{ fontSize: 11, mt: 1, color: Colours.gsblue }}>
              This rule conflicts with a previous rule and may supersede it.
            </Typography>
          )}
        </Box>
      </Box>
    </Card>
  );
}
